import { BasicRequest } from "./basicRequest";

export class EnableSFTPUserRequest extends BasicRequest{

    public sftpUserId? : number;
    public enable : boolean = false;

    constructor(){
        super();
    }
}